import { Bell, Mail, Phone } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export default function Settings() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8">Configurações</h1>

      <div className="max-w-2xl space-y-8">
        <div className="border rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Notificações</h2>
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <Label htmlFor="email-notifications">Notificações por email</Label>
              </div>
              <Switch id="email-notifications" />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <Label htmlFor="whatsapp-notifications">
                  Notificações por WhatsApp
                </Label>
              </div>
              <Switch id="whatsapp-notifications" />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Bell className="h-4 w-4" />
                <Label htmlFor="reminder-notifications">
                  Lembretes de novas cartas
                </Label>
              </div>
              <Switch id="reminder-notifications" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}